/* eslint-disable react/no-array-index-key */
import React from 'react'
import { useStoreState } from 'easy-peasy'
import styled, { css } from 'styled-components'
import components from '../components/common'

const Container = styled.div`
  text-align: center;
  .styled-btn-action.paticipate {
    ${props =>
      props.locale === 'en-us' &&
      css`
        margin: 0 auto 0 !important;
      `}
  }
`

export default function Landing({ children }) {
  const [landing, locale] = useStoreState(state => [
    state.landing.landing,
    state.locale.locale,
  ])

  return (
    <>
      {landing.firstComponents &&
        landing.firstComponents.map((item, i) => {
          const TypeComponent = components[item.type]
          return (
            <TypeComponent
              key={`component-${item.type}-${i}`}
              config={item.config}
            />
          )
        })}
      <Container className="col" locale={locale}>
        {children}
      </Container>
      {landing.lastComponents &&
        landing.lastComponents.map((item, i) => {
          const TypeComponent = components[item.type]
          return (
            <TypeComponent
              key={`component-${item.type}-${i}`}
              config={item.config}
            />
          )
        })}
    </>
  )
}
